module.exports = __webpack_public_path__ + "static/19th-1c34b157fca0f161fdef326970f9d45a.png";